// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 167 ? "80289b8c" : chunkId) + "." + {"167":"d584130a0a5e7652","171":"d524a2c9115f9903","753":"e3bea01958f3ea2c"}[chunkId] + ".js";
};